var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.group_name === 'Alocação por estratégia')?_c('portfolio-allocation-component',{attrs:{"data":_vm.data}}):_c('div',[_c('param-group-component',{attrs:{"group":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }